var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10634_54311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03418 3C4.56621 3 2.56543 4.94292 2.56543 7.33952C2.56543 11.679 7.84668 15.6241 10.6904 16.5417C13.5342 15.6241 18.8154 11.679 18.8154 7.33952C18.8154 4.94292 16.8146 3 14.3467 3C12.8354 3 11.4989 3.72865 10.6904 4.8439C10.2784 4.27393 9.73093 3.80876 9.09449 3.4878C8.45805 3.16683 7.75133 2.99951 7.03418 3Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0654,
    cy: 3.5,
    r: 3.5,
    fill: "#EE7734"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10634_54311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.56543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/newIcon.caaab2877a7f76d4516985034ecf3ece.svg";
export { ForwardRef as ReactComponent };